module.exports = __webpack_public_path__ + "static/media/dewi_anjani.9d4b8bf5.jpg";